import { Component, ViewChild } from '@angular/core';
import { PromotionService, ContractItemModel, CorpInfo, BannerStatistics } from '../../../services/index'
declare var moment:any;
import _ from 'lodash';
import { AgGridNg2 } from 'ag-grid-angular';
import { GridApi } from 'ag-grid';

@Component({
  selector: 'statistics-list',
  templateUrl: 'statistics-list.html'
})
export class StatisticsListComponent {

  startDt:string = moment().subtract(1, 'M').format('YYYYMMDD');;
  endDt:string = moment().format('YYYYMMDD');
  contractList: Array<ContractItemModel> = [];
  contractCorpList : Array<CorpInfo> = [];
  corpId = '';
  columnDefs;
  statisticsList: Array<BannerStatistics> = [];

  @ViewChild('gridStatistics') gridStatistics: AgGridNg2;
  gridApi: GridApi;


  constructor(
    private promotionService: PromotionService
  ) {
    this.columnDefs = [
      {
        headerName: '회사명',
        field: 'corpNm',
        editable: false,
        width: 150
      },
      {
        headerName: '조회수',
        field: 'viewCnt',
        editable: false,
        width: 150
      },
      {
        headerName: '국가',
        field: 'cntryNm',
        editable: false,
        width: 150
      },
      {
        headerName: '클릭수',
        field: 'clickCnt',
        editable: false,
        width: 150
      },
    ];
  }

  ngOnInit(){
    this.promotionService.getContractList().subscribe((res:any)=>{
      this.contractList = res.data;

      this.contractList.map(contract => {
        this.contractCorpList.push(contract.corporation);
      })
    });

    this.conditionSearch();
  }

  parseToDate(dateStr:string) {
    return moment(dateStr, 'YYYYMMDD').toDate();
  }

  setStartDtm($event) {
    this.startDt = moment($event).format('YYYYMMDD');
    this.conditionSearch();
  }

  setEndDtm($event) {
    this.endDt = moment($event).format('YYYYMMDD');
    this.conditionSearch();
  }

  selecedCorp(event) {
    if(event != null) {
      this.corpId = event.corpId;
    } else {
      this.corpId = '';
    }
    
    this.conditionSearch();
  }

  conditionSearch() {
    this.promotionService.getStatisticsList(this.corpId, this.startDt, this.endDt).subscribe((res:any) => {
      this.statisticsList = res.data;
    })
  }

  onGridTransReady(params) {
    this.gridApi = params.api;
    params.api.sizeColumnsToFit();
  }

}


// WEBPACK FOOTER //
// ./src/app/containers/promotion/statistics/statistics-list.ts